var _style, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BCBDBF;}\n\t.st1{fill:#FEFEFE;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 300,
    height: 300
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.1,138.8c-4.4,0.1-36.7-0.5-35.6-38.8C115.6,59,150,61.9,150,61.9h0.1c0,0,34.4-2.9,35.5,38.2 C186.6,138,154.9,138.9,150.1,138.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.1,219.6c-3.2,18.9-46.6,27-73.6,26.3c-0.5,0-2.4,0-2.8,0c-27,0.7-70.4-7.5-73.6-26.3 c-3.2-18.9,5-44.1,5-44.1c13.9-26.7,50.2-27.7,50.2-27.7h39.8c0,0,36.3,1.1,50.2,27.7C220.1,175.5,228.3,200.7,225.1,219.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.757ed7735ff8eb32db806675b8a0c5ab.svg";
export { ForwardRef as ReactComponent };